import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSession } from "@core/session/SessionProvider";

// SPEC-201 §3 / SPEC-003 §3.4: un usuario con mustChangePassword solo puede
// acceder a la pantalla de cambio; cualquier otra ruta lo devuelve ahí.
export function RequirePasswordChange() {
  const { session } = useSession();
  const location = useLocation();

  if (session?.mustChangePassword && location.pathname !== "/change-password") {
    return <Navigate to="/change-password" replace />;
  }

  return <Outlet />;
}
